module.exports = __webpack_public_path__ + "img/textData.3fb42d13.png";